import React, { useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { HomeScreen, IntakeScreen, ChatScreen, PetsScreen, VideoAppointmentScreen, VideoAvailabilityScreen, VideoLiveScreen, ProviderMessagesScreen } from './screens';
import './App.css';
import { useNavigate, useLocation      } from 'react-router-dom';
import { Routes as routes } from './navigation';
import { SessionExpired }         from './containers';
import { SessionExpiringBanner }  from './components';
import SessionExpiry              from './utils/SessionExpiry';

let App = () => {
  let navigate = useNavigate();
  let location = useLocation();

  // Session lifetime is tracked here, above the routes, so the expired screen replaces
  // whichever screen the user is on and the warning strip shows on all of them.
  let [session_expired,  set_session_expired]  = useState(false);
  let [session_expiring, set_session_expiring] = useState(false);

  useEffect(() => {
    let on_expiring = () => { set_session_expiring(true); };
    let on_expired  = () => { set_session_expiring(false); set_session_expired(true); };

    window.addEventListener(SessionExpiry.EXPIRING_EVENT, on_expiring);
    window.addEventListener(SessionExpiry.EXPIRED_EVENT,  on_expired);
    SessionExpiry.bind_window_listeners();
    SessionExpiry.init_from_storage();

    return () => {
      window.removeEventListener(SessionExpiry.EXPIRING_EVENT, on_expiring);
      window.removeEventListener(SessionExpiry.EXPIRED_EVENT,  on_expired);
    };
  }, []);

  if (session_expired) {
    return <SessionExpired variant='expired' />;
  }

  return (
    <>
      { session_expiring ? <SessionExpiringBanner /> : null }
      <Routes>
        <Route exact path={routes.HOME}   element={<HomeScreen   navigate={navigate} />} />
        <Route exact path={routes.INTAKE} element={<IntakeScreen navigate={navigate} />} />
        <Route exact path={routes.PETS}   element={<PetsScreen   navigate={navigate} />} />
        <Route exact path={routes.HOME  + '/:code'}       element={<HomeScreen              navigate={navigate} />} />
        <Route exact path={routes.HOME  + '/connected/:session_code'} element={<HomeScreen  navigate={navigate} />} />
        <Route exact path={routes.CHAT  + '/:code'}       element={<ChatScreen              navigate={navigate} />} />
        <Route exact path={routes.APPOINTMENT + '/:code'} element={<VideoAppointmentScreen  navigate={navigate} />} />
        <Route exact path={routes.AVAILABILITY}           element={<VideoAvailabilityScreen navigate={navigate} />} />
        <Route exact path={routes.LIVE_VIDEO + '/:code' } element={<VideoLiveScreen         navigate={navigate} />} />
        <Route exact path={routes.PROVIDER_MESSAGES} element={<ProviderMessagesScreen navigate={navigate} location={location} />} />
        <Route exact path={routes.PROVIDER_MESSAGES + '/:code'} element={<ProviderMessagesScreen navigate={navigate} location={location} />} />
      </Routes>
    </>
  );
}

export default App;
